// extracted by mini-css-extract-plugin
module.exports = {"imagePanel":"index-imagePanel-H2R4d","downBtn":"index-downBtn-13Vjj","closeBtn":"index-closeBtn-VwjqL"};